export const patternValidatorKey = 'pattern';
export const patternValidator = (pattern) => {
    return (value) => {
        const isValid = pattern.test(value);
        return {
            [patternValidatorKey]: isValid,
        };
    };
};
//# sourceMappingURL=pattern.validator.js.map